import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-datenschutz',
  templateUrl: './datenschutz.component.html',
  styleUrls: ['./datenschutz.component.scss'],
  imports: [],
})
export class DatenschutzComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
